import "./paymentFail.css";
import { GiCancel } from "react-icons/gi";
import { useNavigate } from "react-router-dom";

const PaymentFail = () => {
  const navigate = useNavigate();

  return (
    <div className="paymentFail">
      <div className="paymentFail__container">
        <GiCancel className="paymentFail__container__icon" />
        <h1 className="paymentFail__container__header">Payment Failure!</h1>
        <p>
          Please try again. If you continue to get this message then please
          contact our support.
        </p>
        <button
          className="paymentFail__container__btn"
          onClick={() => {
            navigate("/dashboard/plans");
          }}
        >
          Go Back to Pricing
        </button>
      </div>
      ;
    </div>
  );
};

export default PaymentFail;
